export enum ProfileEnum {
  CLIENT = 'client',
  WORKER = 'worker',
}
